<template>
  <!-- Main Sidebar Container -->
  <div class="sidebar-container">
    <aside class="main-sidebar sidebar-light elevation-2">
      <a
        href="https://www.soscontingencias.com.co/"
        class="brand-link sidebar-brand"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          :src="logoSupport"
          alt="Support 7-24"
          class="sidebar-brand__logo"
        />
      </a>
      <!-- Sidebar -->
      <div class="sidebar">
        <!-- SidebarSearch Form -->
        <div class="form-inline">
          <div class="input-group mt-2">
            <input
              class="form-control form-control-sidebar"
              type="search"
              placeholder="Search"
              aria-label="Search"
              v-model="filtro"
            />
            <div class="input-group-append">
              <button class="btn btn-sidebar">
                <i class="fas fa-search fa-fw"></i>
              </button>
            </div>
          </div>
        </div>

        <!-- Sidebar Menu -->
        <nav class="mt-2">
          <ul
            class="nav nav-pills nav-sidebar flex-column"
            data-widget="treeview"
            role="menu"
            data-accordion="false"
          >
            <li
              class="nav-item"
              v-for="menu in filterMenu"
              :key="menu.id"
            >
              <a
                href="#"
                class="nav-link bg-support-menu text-dark"
              >
                <i
                  class="nav-icon"
                  :class="menu.icono"
                ></i>
                <p>
                  {{ menu.nombre }}
                  <i class="right fas fa-angle-left"></i>
                </p>
              </a>
              <ul
                class="nav nav-treeview pl-2"
                v-if="menu.nivel2.length > 0"
              >
                <li
                  class="nav-item"
                  v-for="nivel2 in menu.nivel2"
                  :key="nivel2.id"
                >
                  <router-link
                    :to="pathParaItem(nivel2)"
                    class="nav-link"
                    :class="
                      menuActivo(nivel2)
                        ? 'bg-support text-white'
                        : ''
                    "
                  >
                    <i
                      class="nav-icon"
                      :class="nivel2.icono"
                    ></i>
                    <p>{{ nivel2.nombre }}</p>
                  </router-link>
                </li>
              </ul>
            </li>
          </ul>
        </nav>
        <!-- /.sidebar-menu -->
      </div>
      <!-- /.sidebar -->
      <div class="sidebar-footer">
        <a
          href="https://www.soscontingencias.com.co/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            :src="logoSos"
            alt="S.O.S Contingencias"
            class="sidebar-footer__logo"
          />
        </a>
      </div>
    </aside>
  </div>
</template>

<script>
export default {
  name: "NavBarLeft",

  data() {
    return {
      filtro: "",
    };
  },
  methods: {
    /** Ruta absoluta para un ítem de menú: usa menus.ruta o, si viene vacía, la path de componentes_rutas (rutas[0]). */
    pathParaItem(nivel2) {
      const ruta =
        nivel2?.ruta ||
        (nivel2?.rutas && nivel2.rutas[0] && nivel2.rutas[0].path);
      if (!ruta) return "/";
      return ruta.startsWith("/") ? ruta : "/" + ruta;
    },
    menuActivo(nivel2) {
      const path = this.pathParaItem(nivel2);
      const current = this.$route.path;

      if (current === path) {
        return true;
      }

      // Sub-rutas del mismo ítem (ej. Constructor/Nuevo, Constructor/5)
      if (path !== "/" && current.startsWith(`${path}/`)) {
        return true;
      }

      // Sesiones (briefing, ejecución, etc.) pertenecen al catálogo Escenarios
      if (
        path.endsWith("/Simulacros/Escenarios") &&
        current.startsWith("/Sos/Emergencias/Simulacros/Sesion/")
      ) {
        return true;
      }

      return false;
    },
  },
  computed: {
    isDark() {
      return this.$store.getters.getDarkMode;
    },
    logoSupport() {
      return this.isDark
        ? "/img/logos/Logo-Support-7-24-Negativo.png"
        : "/img/logos/Logo-Support-7-24.png";
    },
    logoSos() {
      return this.isDark
        ? "/img/logos/logo-negativo.png"
        : "/img/logos/logo-sos.png";
    },
    filterMenu() {
      if (this.$store.state.menus) {
        return this.$store.state.menus
          .map((res1) => {
            const nuevosNiveles2 = res1.nivel2
              .map((res2) => {
                const nMenu = res2.nombre.toString().toLowerCase();
                const search = this.filtro.toLowerCase();
                return nMenu.includes(search) ? res2 : null;
              })
              .filter(Boolean);

            return nuevosNiveles2.length > 0
              ? { ...res1, nivel2: nuevosNiveles2 }
              : null;
          })
          .filter(Boolean);
      } else {
        return this.$store.state.menus;
      }
    },
  },
};
</script>

<style>
.sidebar-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.main-sidebar {
  z-index: 1030;
  max-height: 100vh;
  overflow-y: hidden;
  display: flex;
  flex-direction: column;
}

.sidebar {
  position: relative;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: calc(100vh - 150px);
}

/* Logo Support (arriba): ancho completo, sin recortes de AdminLTE */
.main-sidebar .brand-link.sidebar-brand {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0;
  float: none;
  width: 100%;
  max-height: none;
  padding: 0.65rem 0.75rem;
  overflow: visible;
  border-bottom: 2px solid #bad35c;
}

.main-sidebar .brand-link.sidebar-brand .sidebar-brand__logo,
.main-sidebar .brand-link.sidebar-brand .brand-image {
  float: none !important;
  margin: 0 !important;
  padding: 0 !important;
  box-shadow: none !important;
  border-radius: 0 !important;
  display: block;
  width: 100%;
  max-width: 132px;
  height: auto;
  max-height: 40px;
  object-fit: contain;
  object-position: center;
  /* PNG trae fondo negro: lo hace transparente sobre el panel claro */
  mix-blend-mode: screen;
}

body.dark-mode .main-sidebar .brand-link.sidebar-brand .sidebar-brand__logo {
  mix-blend-mode: screen;
  max-width: 132px;
}

/* Logo SOS (abajo): tamaño legible, sin círculo ni opacidad baja */
.main-sidebar .sidebar-footer {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.75rem 0.5rem 1rem;
  border-top: 1px solid rgba(21, 63, 117, 0.12);
  background: transparent;
}

.main-sidebar .sidebar-footer__link {
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 0;
}

.main-sidebar .sidebar-footer__logo {
  display: block;
  width: 58px;
  height: auto;
  max-width: 100%;
  object-fit: contain;
  border-radius: 0;
  box-shadow: none;
  opacity: 1;
  mix-blend-mode: screen;
}

body.dark-mode .main-sidebar .sidebar-footer {
  border-top-color: rgba(255, 255, 255, 0.12);
}

body.dark-mode .main-sidebar .sidebar-footer__logo {
  mix-blend-mode: screen;
  width: 58px;
}
</style>
